import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { RTLDivDirectiveDirective } from '../../directives/rtldiv-directive.directive';
import { Overview } from './overview/overview';
import { Invoices } from './invoices/invoices';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslatorService } from '../../services/translator_service';
import { Router } from '@angular/router';
import { ApiQuery } from '../../web-services/api/api.query';
import { ApiStore } from '../../web-services/api/api.store';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { LOCAL_STORAGE_KEYS } from '../../constants';

@Component({
  selector: 'app-billing',
  imports: [CommonModule, RTLDivDirectiveDirective, Overview, Invoices, TranslatePipe],
  templateUrl: './billing.html',
  styleUrl: './billing.scss',
})
export class Billing implements OnInit {
  translationsObj: any;
  currentLang: any;
  activeView: 'overview' | 'invoices' = 'overview';
  userInfo: any;
  profileMenuOpen = false;
  version_number: String;

  @HostListener('document:click')
  onDocumentClick() {
    this.profileMenuOpen = false;
  }

  constructor(
    private translator: TranslatorService,
    private location: Location,
    private router: Router,
    private apiQuery: ApiQuery,
    private apiStore: ApiStore,
    private dialog: MatDialog
  ) {
    this.translator.currentLangEmitter$.subscribe(async value => {
      this.translationsObj = await this.translator.getTranslation(value).toPromise();
      this.currentLang = value;
    });
    this.version_number = environment.appVersion;
  }

  ngOnInit(): void {
    this.apiQuery.user$.subscribe((user: any) => {
      if (!user) return;
      this.userInfo = user;
    });
  }

  goBack(): void {
    this.location.back();
  }

  toggleProfileMenu() {
    this.profileMenuOpen = !this.profileMenuOpen;
  }

  onReqToLogOut() {
    this.profileMenuOpen = false;
    this.logout();
  }

  logout() {
    this.dialog.closeAll();

    this.apiStore.update({
      allFilteredDailyWorkPlan: [],
      filteredDailyWorkPlan: [],
      allFilteredBasicBins: [],
      filteredBasicBins: [],
      allCollectionsKpis: [],
      collectionsKpis: [],
      collectionsStatsInCollections: [],
      allCollectionsStats: [],
      allRefillsKpis: [],
      refillsKpis: [],
      allRefillsStats: [],
      refillsStats: [],
      userEventsByType: [],
      filteredBins: [],
      collectionVolume: [],
      exceptionsReports: [],
      allDailyWorkPlanCalanderData: [],
      dailyWorkPlanCalanderData: [],
      allWorkPlanScheduler: [],
      workPlanScheduler: [],
      allSitesListData: [],
      sitesListData: []
    });

    const sessionKeys = [
      'fillingsMinDate', 'fillingsMaxDate', 'fillingsStartDate', 'fillingsEndDate',
      'collectionsMinDate', 'collectionsMaxDate', 'collectionsStartDate', 'collectionsEndDate',
      'reportsMinDate', 'reportsMaxDate', 'reportsStartDate', 'reportsEndDate',
      'ticketManagementMinDate', 'ticketManagementMaxDate', 'ticketManagementStartDate', 'ticketManagementEndDate',
      'insightsMinDate', 'insightsMaxDate', 'insightsStartDate', 'insightsEndDate',
      'blackStatusBin'
    ];
    sessionKeys.forEach(key => sessionStorage.removeItem(key));

    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
    localStorage.removeItem('language');

    this.router.navigate(['/login']);
  }
}
